import {SELECIONAR_PRESTADOR} from '../types';

export default function selecionarPrestador (data) {
  return {
    type: SELECIONAR_PRESTADOR,
    payload: data
  }
}
